import React from "react";
import { Route, Switch } from "react-router-dom";
import NotFoundPage from "./components/NotFoundPage";
import App from "./app/App";
import "./styles/Panel.less";
import ConstantStore from "../../stores/ConstantStore";
import TourRoutes from "./routes/TourRoutes";
import CustomerProfileRoutes from "./routes/CustomerProfileRoutes";
import UiMeet3dRoutes from "./routes/UiMeet3dRoutes";
import ToastMessageStore from "~/stores/ToastMessageStore";
import BillingCentralRoutes from "./routes/BillingCentralRoutes";

const constantStore = new ConstantStore();
const toastMessageStore = new ToastMessageStore();

export default (
  <App>
    {(user, userStore) => (
      <Switch>
        <Route path="/tours">
          <TourRoutes constantStore={constantStore} user={user} toastMessageStore={toastMessageStore} />
        </Route>
        <Route path="/profile">
          <CustomerProfileRoutes constantStore={constantStore} user={user} toastMessageStore={toastMessageStore} />
        </Route>
        <Route
          path="/billing-central"
          render={props => (
            <BillingCentralRoutes
              {...props}
              constantStore={constantStore}
              user={user}
              toastMessageStore={toastMessageStore}
            />
          )}
        />
        <Route path="/ui-meet-3d">
          <UiMeet3dRoutes user={user} userStore={userStore} toastMessageStore={toastMessageStore} />
        </Route>

        <Route path="*" component={NotFoundPage} />
      </Switch>
    )}
  </App>
);
